module.exports = __webpack_public_path__ + "static/media/First-Responder-Middle.82b90cbe.jpg";